"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.includes.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ContextType", {
  enumerable: true,
  get: function get() {
    return _constants.ContextType;
  }
});
Object.defineProperty(exports, "CustomCtxType", {
  enumerable: true,
  get: function get() {
    return _constants.CustomCtxType;
  }
});
Object.defineProperty(exports, "useApolloNetworkStatus", {
  enumerable: true,
  get: function get() {
    return _initApollo.useApolloNetworkStatus;
  }
});
exports.buildWithApollo = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _constants = require("./constants");

var _react = _interopRequireDefault(require("react"));

var _client = require("@apollo/client");

var _ssr = require("@apollo/client/react/ssr");

var _logger = require("@meepshop/logger");

var _ApolloNetworkStatus = _interopRequireDefault(require("./ApolloNetworkStatus"));

var _initApollo = _interopRequireWildcard(require("./utils/initApollo"));

var _log = require("@meepshop/logger/lib/gqls/log");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// definition
var buildWithApollo = function buildWithApollo(_ref) {
  var hoc = _ref.hoc,
      getServerSideAppProps = _ref.getServerSideAppProps,
      getClientSideAppProps = _ref.getClientSideAppProps,
      config = (0, _objectWithoutProperties2["default"])(_ref, ["hoc", "getServerSideAppProps", "getClientSideAppProps"]);

  var getServerProps = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(appContext, app) {
      var _Component$getInitial;

      var Component, router, ctx, req, loggerInfo, client, AppWithHoc, serverSideAppProps, pageProps, appProps, _error$networkError;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              Component = appContext.Component, router = appContext.router, ctx = appContext.ctx;
              req = ctx.req; // FIXME: T10566, remove after next >= 12

              if (process.env.MEEPSHOP_STORE_DOMAIN) req.headers.host = process.env.MEEPSHOP_STORE_DOMAIN;
              loggerInfo = (0, _logger.getServerSideLoggerInfo)(appContext.ctx); // Initialize Apollo

              client = (0, _initApollo["default"])(_objectSpread(_objectSpread({}, config), {}, {
                loggerInfo: loggerInfo
              }), undefined, appContext); // Set Apollo Instance to ctx.client

              ctx.client = client;
              AppWithHoc = hoc(app); // Server Side App Props

              _context.next = 9;
              return getServerSideAppProps(appContext);

            case 9:
              serverSideAppProps = _context.sent;
              _context.next = 12;
              return (_Component$getInitial = Component.getInitialProps) === null || _Component$getInitial === void 0 ? void 0 : _Component$getInitial.call(Component, ctx);

            case 12:
              _context.t0 = _context.sent;

              if (_context.t0) {
                _context.next = 15;
                break;
              }

              _context.t0 = {};

            case 15:
              pageProps = _context.t0;
              appProps = _objectSpread(_objectSpread({}, serverSideAppProps), {}, {
                pageProps: _objectSpread(_objectSpread({}, serverSideAppProps.pageProps), pageProps)
              }); // Server side 才會 getDataFromTree

              _context.prev = 17;
              _context.next = 20;
              return (0, _ssr.getDataFromTree)( /*#__PURE__*/_react["default"].createElement(_client.ApolloProvider, {
                client: client
              }, /*#__PURE__*/_react["default"].createElement(AppWithHoc, (0, _extends2["default"])({}, appProps, {
                Component: Component,
                router: router
              }))));

            case 20:
              _context.next = 27;
              break;

            case 22:
              _context.prev = 22;
              _context.t1 = _context["catch"](17);

              if (![401, 403].includes((_error$networkError = _context.t1.networkError) === null || _error$networkError === void 0 ? void 0 : _error$networkError.statusCode)) {
                _context.next = 26;
                break;
              }

              return _context.abrupt("return", _objectSpread(_objectSpread({}, appProps), {}, {
                error: _context.t1
              }));

            case 26:
              client.mutate({
                mutation: _log.log,
                variables: {
                  input: {
                    type: 'ERROR',
                    name: 'GET_DATA_FROM_TREE',
                    data: {
                      message: _context.t1.message,
                      stack: _context.t1.stack
                    }
                  }
                }
              });

            case 27:
              return _context.abrupt("return", _objectSpread(_objectSpread({}, appProps), {}, {
                apolloState: client.extract(),
                loggerInfo: loggerInfo
              }));

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[17, 22]]);
    }));

    return function getServerProps(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var appWithApollo = function appWithApollo(app) {
    // HOC , ex. appWithCookies, appWithDomain
    var AppWithHoc = hoc(app);

    var WithApollo = function WithApollo(_ref3) {
      var apolloState = _ref3.apolloState,
          loggerInfo = _ref3.loggerInfo,
          props = (0, _objectWithoutProperties2["default"])(_ref3, ["apolloState", "loggerInfo"]);
      return /*#__PURE__*/_react["default"].createElement(_client.ApolloProvider, {
        client: (0, _initApollo["default"])(_objectSpread(_objectSpread({}, config), {}, {
          loggerInfo: loggerInfo
        }), apolloState)
      }, /*#__PURE__*/_react["default"].createElement(_ApolloNetworkStatus["default"], null), /*#__PURE__*/_react["default"].createElement(AppWithHoc, (0, _extends2["default"])({}, props, {
        loggerInfo: loggerInfo
      })));
    };

    WithApollo.getInitialProps = /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(appContext) {
        var _Component$getInitial2;

        var ctx, Component, serverProps, clientSideAppProps, pageProps;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ctx = appContext.ctx, Component = appContext.Component; // Server Side

                if (!(typeof window === 'undefined')) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 4;
                return getServerProps(appContext, app);

              case 4:
                serverProps = _context2.sent;
                return _context2.abrupt("return", serverProps);

              case 6:
                // Client Side
                // 把 apollo 實體傳進 ctx.client ，page getInitialProps 就可以 access ctx.client
                ctx.client = (0, _initApollo["default"])(config);
                _context2.next = 9;
                return getClientSideAppProps(appContext);

              case 9:
                clientSideAppProps = _context2.sent;
                _context2.next = 12;
                return (_Component$getInitial2 = Component.getInitialProps) === null || _Component$getInitial2 === void 0 ? void 0 : _Component$getInitial2.call(Component, ctx);

              case 12:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 15;
                  break;
                }

                _context2.t0 = {};

              case 15:
                pageProps = _context2.t0;
                return _context2.abrupt("return", _objectSpread(_objectSpread({}, clientSideAppProps), {}, {
                  pageProps: _objectSpread(_objectSpread({}, clientSideAppProps.pageProps), pageProps)
                }));

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }();

    return WithApollo;
  };

  return {
    appWithApollo: appWithApollo
  };
}; // Types


exports.buildWithApollo = buildWithApollo;